module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wizard_desktop-3c84495216f7d19d4fae2b2c9129cdb4.png";